module.exports = __webpack_public_path__ + "img/ico_footer_chatbot.ca13edc.svg";